module.exports = __webpack_public_path__ + "static/media/test.f7ea83b6.jpg";